import { IItemForGetShortInfo } from 'types';
import {
	TEditGameSelectedItem,
	TTypeOfEditGameModalWindow,
} from 'modules/Entertainment/Games/EditGame/editGameState/editGameContext';
import React from 'react';
import DeveloperSelect from './components/DeveloperSelect';
import CreateDeveloperBtn from './components/CreateDeveloperBtn';
import style from './DeveloperField.module.scss';

interface IDeveloperField {
	setIDDeveloper: (value: TEditGameSelectedItem) => void;
	setFetchedDevelopers: (value: IItemForGetShortInfo[]) => void;
	refetchDevelopers: (value: boolean) => void;
	needRefetchDevelopers: boolean;
	changeTypeOfModalWindow: (value: TTypeOfEditGameModalWindow) => void;
}

const DeveloperField: React.FC<IDeveloperField> = ({
	needRefetchDevelopers,
	refetchDevelopers,
	setFetchedDevelopers,
	setIDDeveloper,
	changeTypeOfModalWindow,
}) => {
	return (
		<div className={style.container}>
			<DeveloperSelect
				needRefetchDevelopers={needRefetchDevelopers}
				refetchDevelopers={refetchDevelopers}
				setFetchedDevelopers={setFetchedDevelopers}
				setIDDeveloper={setIDDeveloper}
			/>
			<CreateDeveloperBtn changeTypeOfModalWindow={changeTypeOfModalWindow} />
		</div>
	);
};

export default React.memo(DeveloperField);
